import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2DownloadOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="m28 26-1.4 2H4v-8h2v6zm0-6h-2v4h2zm-2.303-5.283-1.394-1.434-7.303 7.1V4h-2v16.383l-7.303-7.1-1.394 1.434L16 24.144z" /></svg>
);
